import { Wrapper } from '@american-autonomy/ag-ui';

import Link from 'components/Link';
import CaptionText from 'components/text/CaptionText';
import LabelText from 'components/text/LabelText';

import { ENTITY_TYPE_LABELS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewEntityLink: FunctionComponent<Props> = ({
    className = '',
    entityName,
    entityRoute,
    entityType,
    testId = TEST_ID
}) => (
    <Wrapper className={`${className} ${styles.detailsViewEntityLink}`} testId={testId}>
        <CaptionText>{ENTITY_TYPE_LABELS[entityType]}:</CaptionText>

        {entityRoute === undefined ? (
            <LabelText className={styles.labelText} text={entityName} />
        ) : (
            <Link className={styles.link} text={entityName} to={entityRoute} />
        )}
    </Wrapper>
);

export default DetailsViewEntityLink;
